import { useState } from 'react';
import {Col, Row} from 'react-bootstrap';

function IminioDataListHeader({ 
    id,
    xs,
    sm,
    md,
    lg,
    padding,
    min,
    max,
    text,
    active=true,
    onChange=()=>{},
}) {

    const [order, setOrder] = useState(false)

    const handleOnClick = () => {
        let currOrder = !order
        setOrder(currOrder)
        return onChange(currOrder===true?'desc':'asc')
    }

    return <Col 
            xs={xs}
            sm={sm}
            md={md}
            lg={lg}
            className={`fg-orange-dark text-9 ${padding?`ps-${padding}`:''}`} 
            style={{minWidth: min || '100px', maxWidth: max || ''}}
            onClick={handleOnClick}
        >
            <Row className="d-flex justify-content-start align-content-center align-items-center text-7">
                {text}
                {
                    !active ? '' :
                    <Col xs={1} className="ms-2" style={{maxHeight: '15px', transform: "translate(0px,-8px)"}}>
                        {
                            order === true ?
                            <i className="fg-orange-dark text-13 mdi mdi-menu-up"></i>
                            :
                            <i className="fg-orange-dark text-13 mdi mdi-menu-down"></i>
                        }
                    </Col>
                }
            </Row>
        </Col>    
}

export default IminioDataListHeader